module.exports = __webpack_public_path__ + "img/backDataHeader.947f061f.png";